import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';
import WindowModel from './WindowModel';
import HandleModel from './HandleModel';

const FifteenLiteDoubleRightKnobWalkInDoor = ({ width, height, trimWidth, doorColor, isOverlap, overlapTrimColor, glassTexture, handleModel }) => {
    const trimColor =  params.p_t_c.replace('0x', '#')
    const doorWidth = (width - trimWidth * 2) / 2;

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [height, trimWidth, width])

    const doorModel = useMemo(() => {
      
        const model = new THREE.Shape();
        model.moveTo(-(doorWidth / 2 - 0.03),  -(height / 2 - 0.03));
        model.lineTo(-(doorWidth / 2 - 0.03),  (height / 2 - 0.03) - trimWidth);
        model.lineTo((doorWidth / 2 - 0.03),  (height / 2 - 0.03) - trimWidth);
        model.lineTo((doorWidth / 2 - 0.03),  -(height / 2 - 0.03));
        model.closePath();
      
        const windowHole = new THREE.Path();
        windowHole.moveTo(-(doorWidth / 2 - doorWidth / 10),  (height / 2 - height / 10));
        windowHole.lineTo(-(doorWidth / 2 - doorWidth / 10),  -(height / 2 - height / 10));
        windowHole.lineTo((doorWidth / 2 - doorWidth / 10),  -(height / 2 - height / 10));
        windowHole.lineTo((doorWidth / 2 - doorWidth / 10),  (height / 2 - height / 10));
        windowHole.closePath();
      
        model.holes.push(windowHole);

        return model;
    }, [doorWidth, height, trimWidth])

  return (
    <>
        <mesh name='trim'>
            <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
            <meshStandardMaterial side={THREE.DoubleSide} color={isOverlap ? overlapTrimColor : trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
        </mesh>
        {new Array(2).fill("").map((_, index) =>
            <group key={`door-model-${index}`} name='door' position={[Math.pow(-1, index) * doorWidth / 2, 0, 0.05]}>
                <mesh name='door-shape'>
                    <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>

                <WindowModel width={width} height={height} trimWidth={trimWidth} trimColor={trimColor} doorColor={doorColor} glassTexture={glassTexture}  />
            </group>
        )}

        <HandleModel doorWidth={doorWidth} handleModel={handleModel} />
    </>
  )
}

export default FifteenLiteDoubleRightKnobWalkInDoor